<template>
  <div>
    <b-table
      show-empty
      empty-text="No hay registros para mostrar, haga una busqueda"
      small
      responsive
      stacked="md"
      :items="filteredOrders"
      :fields="fields"
      class="mt-2"
    >
      <template #cell(actions)="row">
        <div class="text-nowrap">
          <b-button size="sm" variant="primary" :to="{name: 'view-group', params:{ id: row.item.id }}" class="mr-2">
            <feather-icon icon="Edit2Icon" size="12" />
          </b-button>
        </div>
      </template>

    </b-table>
  </div>
</template>

<script>

export default {
  props: {
    filteredOrders: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
  },
};
</script>

